import { STAGE_WORKFLOW } from './constants';

/**
 * Reviewer tiers for CRF header labels — same rules as CRFPageService.GetLatestWorkflowHeaderAsync:
 * prefer StageMst rows with vStageName "Review" between In Progress and Completed; else all stages in that code band.
 * @param {Array<{ stageCode?: number, StageCode?: number, orderNo?: number, OrderNo?: number, stageName?: string, StageName?: string, label?: string, Label?: string }>} stages
 * @returns {Array<{ stageCode: number, label: string, orderNo: number }>}
 */
export function selectReviewerTierStages(stages) {
  if (!Array.isArray(stages) || stages.length === 0) return [];
  const inBand = stages.filter((s) => {
    const code = Number(s.stageCode ?? s.StageCode ?? 0);
    return code > STAGE_WORKFLOW.IN_PROGRESS && code < STAGE_WORKFLOW.COMPLETED;
  });
  const sorted = [...inBand].sort((a, b) => {
    const oa = Number(a.orderNo ?? a.OrderNo ?? 0);
    const ob = Number(b.orderNo ?? b.OrderNo ?? 0);
    if (oa !== ob) return oa - ob;
    return Number(a.stageCode ?? a.StageCode ?? 0) - Number(b.stageCode ?? b.StageCode ?? 0);
  });
  const reviewNamed = sorted.filter(
    (s) => (s.stageName ?? s.StageName ?? '').trim().toLowerCase() === 'review',
  );
  const pick = reviewNamed.length > 0 ? reviewNamed : sorted;
  return pick.map((s) => ({
    stageCode: Number(s.stageCode ?? s.StageCode ?? 0),
    label: String(s.label ?? s.Label ?? '').trim(),
    orderNo: Number(s.orderNo ?? s.OrderNo ?? 0),
  })).filter((r) => r.label.length > 0 && r.stageCode > 0);
}
